import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { loadQuotes, getQuotes } from '../../features/randomquotes/randomQuotesSlice'
import {
  makeStyles,
  Container,
  Fab,
  Fade,
  Tooltip,
} from '@material-ui/core'
import {
  Twitter as TwitterIcon,
  Cached as CachedIcon,
} from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  header: {
    position: 'absolute',
    textAlign: 'center',
    maxWidth: '100vw',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'calc(10px + 2vmin)',
    color: '#FEFEFE',
    backgroundColor: '#rgb(213,151,35)',
    background: `linear-gradient(133deg,
      rgba(163,112,15,1) 0%,
      rgba(94,38,150,1) 15%,
      rgba(2,83,91,1) 50%,
      rgba(12,80,107,1) 70%,
      rgba(12,27,107,1) 100%)`,
  },
  fadeBox: {
    width: '90%',
    maxWidth: theme.breakpoints.values.lg,
  },
  quote: {
    fontFamily: 'Josefin Sans',
    padding: '0 5vw',
    fontSize: '4.5vmax',
    textAlign: 'justify',
    lineHeight: '115%',
  },
  author: {
    fontFamily: 'Lobster',
    textAlign: 'right',
    padding: '20px',
    fontSize: '3.5vmax',
    fontStyle: 'italic',
  },
  footer: {
    width: 'auto',
    position: 'fixed',
    margin: theme.spacing(2),
    bottom: 0,
    right: 0,
    zIndex: 200,
  },
  fabIcon: {
    color: '#FEFEFE',
    marginLeft: theme.spacing(3),
    boxShadow: 'none',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.1)',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(0,0,0,0.15)',
    }
  }
}))

const RandomQuotes = props => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const randomquotes = useSelector(getQuotes)
  const [quote, setQuote] = useState(undefined)
  const [author, setAuthor] = useState(undefined)
  const [fadeIn, setFadeIn] = useState(false)

  const getRandomQuote = () => {
    return randomquotes[Math.floor(
      Math.random() * randomquotes.length
    )]
  }

  const setNewQuote = () => {
    setFadeIn(false)
    let timer = setTimeout(() => {
      let newQuote = getRandomQuote()
      if (newQuote) {
        setQuote('«' + newQuote.quote + '»')
        setAuthor(newQuote.author)
        setFadeIn(true)
      }
    }, 1000)
    return {cancel: () => clearTimeout(timer)}
  }

  useEffect(() => {
    const loadQuotesToStore = async () => {
      setFadeIn(false)
      return dispatch(loadQuotes({}))
    }
    loadQuotesToStore()
  }, [dispatch])

  useEffect(() => {
    let newQuote = setNewQuote()
    //clear timout if unmounted
    return () => {
      newQuote.cancel()
    }
  }, [randomquotes])

  return (
    <React.Fragment>
      <Container component='header' className={classes.header}>
        <Fade in={fadeIn} timeout={1000}>
          <div className={classes.fadeBox}>
            <div className={classes.quote}>
              {quote}
            </div>
            <div className={classes.author}>
              {author}
            </div>
          </div>
        </Fade>
      </Container>

      <Container component='footer' className={classes.footer}>
        <Tooltip title="Get a new quote" arrow aria-label="get-a-new-quote">
          <Fab className={classes.fabIcon} onClick={e => setNewQuote()}>
            <CachedIcon />
          </Fab>
        </Tooltip>
        <Tooltip title="Tweet this quote" arrow aria-label="tweet-this-quote" style={{ fontSize: '5.5rem' }}>
          <Fab className={classes.fabIcon} target='_blank'
            href={'https://twitter.com/intent/tweet?text=' + quote + '%20%20~' + author + '~%20%20&hashtags=randomquote'}>
            <TwitterIcon />
          </Fab>
        </Tooltip>
      </Container>
    </React.Fragment>
  )
}

export default RandomQuotes